import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AppTranslateLoader implements TranslateLoader {
    constructor(protected http: HttpClient) {}

    public getTranslation(lang: string): Observable<object> {
        const folderPath = '/api/text/' + lang;
        return this.http
            .get(folderPath, {
                headers: {
                    'x-skip-version-check': 'skip',
                },
            })
            .pipe(
                catchError(() => {
                    console.error(`No translations in '${folderPath}' for language '${lang}'`);
                    return observableOf({});
                })
            );
    }
}
